// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".fe38a805ad0159ed8e92ec3cc9b70641d95857c7.chunk.bundle.js";
};